module.exports = __webpack_public_path__ + "img/backIcon.21802729.svg";